import { render, staticRenderFns } from "./StepThree.vue?vue&type=template&id=224d2a52&scoped=true"
import script from "./StepThree.vue?vue&type=script&lang=js"
export * from "./StepThree.vue?vue&type=script&lang=js"
import style0 from "./StepThree.vue?vue&type=style&index=0&id=224d2a52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d2a52",
  null
  
)

export default component.exports